<template>
    <el-dialog
        title="地图选址"
        :visible="visible"
        destroy-on-close
        custom-class="mapClass"
        :close-on-click-modal="false"
        :before-close="cancel"
        :append-to-body="true"
        width="70%"
    >
        <div :style="{ height: '100%' }">
            <div ref="mapId" :style="{ height: '100%' }"></div>
            <div class="location-map">
                <el-autocomplete
                    popper-class="map-input-popper"
                    v-model="address"
                    :fetch-suggestions="handleFetch"
                    placeholder="请输入地址搜索"
                    @select="handleSelect"
                >
                    <template slot-scope="{ item }">
                        <div class="title">{{ item.title }}</div>
                        <div class="address">{{ item.address }}</div>
                    </template>
                </el-autocomplete>
            </div>
        </div>
        <span slot="footer">
            <el-button type="primary" class="btn" :loading="loading" @click="sure">确定 </el-button>
            <el-button class="btn" @click="cancel">取消</el-button>
        </span>
    </el-dialog>
</template>
<script>
import loadMap from './loadBMap.js';
import { filterDetailAddress } from './methods.js';
import common from '../../../../../../../api/common.js';

let NewBMap = null; // 地图对象
let local = null; // 地图搜索对象
let queryCallback = null; // 搜索回调
let geocoder = null; // 地图坐标对象
export default {
    name: 'AddressMapModal',
    data() {
        return {
            map: '', // 当前地图对象
            visible: false,
            loading: false,
            type: '',
            address: '',
            point: {}, // 当前经纬度对象
            returnAddress: '', // 地图返回的地址
            mapTitle: '',
            firstTime: false
        };
    },
    methods: {
        // 地图初始化
        mapInit(address) {
            loadMap().then(BMap => {
                NewBMap = BMap;
                this.map = new BMap.Map(this.$refs.mapId);
                local = this.initLocalSearch(this.map);
                if (address) {
                    this.firstTime = true;
                    this.handleLocation(address);
                } else {
                    // 设初始化地图位置
                    this.map.centerAndZoom(new BMap.Point('113.216596', '22.913121'), '15');
                    // 允许地图可被鼠标滚轮缩放
                    this.map.enableScrollWheelZoom(true);
                    // 地图控件
                    const navigationControl = new BMap.NavigationControl({
                        anchor: 'BMAP_ANCHOR_TOP_LEFT', // 控件将定位到地图的左上角
                        type: 'BMAP_NAVIGATION_CONTROL_LARGE' // 标准的平移缩放控件
                    });
                    // 将控件添加到地图
                    this.map.addControl(navigationControl);
                }
                this.map.addEventListener('click', e => {
                    // console.log(e);
                    this.mapClick(e);
                });
            });
        },
        // 初始化地图搜索
        initLocalSearch(map) {
            const local = new NewBMap.LocalSearch(map, {
                // 智能搜索
                onSearchComplete: results => {
                    // state.loading = false;
                    const len = results.getNumPois();
                    const addressOptions = [];
                    if (len <= 0) {
                        queryCallback && queryCallback(addressOptions);
                        return this.$message.warning('没有搜索到相关地址');
                    }
                    map.enableScrollWheelZoom(true);
                    for (let i = 0; i < len; i++) {
                        if (i < 10) {
                            addressOptions.push(results.getPoi(i));
                        }
                    }
                    // console.log('addressOptions', addressOptions);
                    queryCallback && queryCallback(addressOptions);
                    if (this.firstTime) {
                        this.setMarker(addressOptions[0]);
                        this.firstTime = false;
                    }
                }
            });
            return local;
        },
        setMarker(addressOption) {
            const { title, address, point } = addressOption;
            const marker = new NewBMap.Marker(point);
            // 创建信息窗口
            const opts = {
                width: 250,
                title
            };
            this.map.clearOverlays(); // 清除地图上所有覆盖物
            this.map.centerAndZoom(point, '18');
            this.map.addOverlay(marker); // 添加标注
            this.map.setViewport([point]); // 最佳视角

            this.mapTitle = title;
            this.returnAddress = address;
            this.point = point;
            const infoWindow = new NewBMap.InfoWindow('地址:' + address + title, opts); // 创建信息窗口对象
            this.map.openInfoWindow(infoWindow, point); // 开启信息窗口
        },
        handleLocation(query) {
            if (query) {
                local.search(query);
            }
        },
        mapClick(e) {
            if (!geocoder) {
                geocoder = new NewBMap.Geocoder();
            }
            geocoder.getLocation(e.point, result => {
                const { surroundingPois, point } = result;
                // console.log(surroundingPois);return;
                if (surroundingPois.length) {
                    this.address = surroundingPois[0].address + surroundingPois[0].title;
                    this.setMarker({ title: surroundingPois[0].title, address: surroundingPois[0].address, point });
                    // this.addressOptions = [];
                    // for (let i = 0; i < surroundingPois.length; i++) {
                    //     if (i < 10) {
                    //         this.addressOptions.push(surroundingPois[i]);
                    //     }
                    // }
                }
            });
        },
        // 远程搜索
        handleFetch(query, callback) {
            if (query) {
                this.handleLocation(query);
                queryCallback = callback;
            } else {
                // eslint-disable-next-line standard/no-callback-literal
                callback([]);
            }
        },
        handleSelect(val) {
            this.address = val.address + val.title;
            this.setMarker(val);
        },
        open(address, type) {
            this.visible = true;
            this.address = address;
            this.type = type;
            this.mapInit(address);
        },
        sure() {
            if (!this.returnAddress) return this.$message.warning('请选择地址');
            // console.log('sure...', this);
            const address = this.returnAddress + this.mapTitle;
            this.loading = true;
            const { lng, lat } = this.point;
            common.geDetailAddressByGis({ lng, lat })
                .then(res => {
                    if (res && +res.code === 0) {
                        const { code, province, city, county, name } = res.data;
                        const type = this.type;
                        this.visible = false;
                        const fullAddress = filterDetailAddress(province, city, county, name, address);
                        this.$emit(
                            'setSelectedAddress',
                            {
                                [`${type}DetailAddr`]: fullAddress,
                                [`${type}ProvinceCode`]: code && code.length > 2 ? code.slice(0, 3) : '',
                                [`${type}ProvinceName`]: province,
                                [`${type}CityCode`]: code && code.length > 4 ? code.slice(0, 5) : '',
                                [`${type}CityName`]: city,
                                [`${type}DistrictCode`]: code && code.length > 6 ? code.slice(0, 7) : '',
                                [`${type}DistrictName`]: county,
                                [`${type}TownCode`]: code,
                                [`${type}TownName`]: name,
                                [`${type}Lng`]: lng,
                                [`${type}Lat`]: lat,
                                fullAddress
                            },
                            type
                        );
                    }
                })
                .catch(() => {
                    this.$message.warning('未获取到当前所选地址的详细信息，请重新选择');
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        cancel() {
            this.visible = false;
        }
    }
};
</script>
<style lang="less">
.mapClass {
    .el-dialog__body {
        position: relative;
        height: 500px;
        .location-map {
            position: absolute;
            top: 2%;
            right: 1%;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 5px 10px;
            border-radius: 4px;
            background-color: #fff;
            box-shadow: 0 0 5px #f2f2f2;
            .el-autocomplete .el-input__inner {
                width: 560px;
            }
        }
    }
}
</style>
